var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-progress-linear", {
        staticClass: "progressbar",
        attrs: {
          active: _vm.progressActive,
          indeterminate: _vm.progressIndeterminate,
          color: "primary",
          "background-color": "secondary",
          height: _vm.progBarHeight
        }
      }),
      _vm._v(" "),
      _c(
        "v-card",
        {
          staticClass: "list-container",
          attrs: { flat: "", "max-height": _vm.maxHeight }
        },
        [
          _vm._l(_vm.data, function(item) {
            return _vm._t("default", null, { tile: item })
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f7b08c64", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7b08c64","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FactSheet_Sip.vue
// module id = null
// module chunks = 